import { prop } from 'ramda';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from 'js/store/hooks';
import { pushDispatcher } from 'js/hooks/socket/hooks/usePushSubscription';

export const useLegacyEmailVerificationTrigger = () => {
    const { search } = useLocation();
    const emailVerificationParam = useAppSelector(prop('emailVerificationParam'));

    useEffect(() => {
        if (!emailVerificationParam) {
            return;
        }

        const params = new URLSearchParams(search);
        const token = params.get(emailVerificationParam);

        if (!token) {
            return;
        }

        pushDispatcher.trigger('emailVerificationStatus', token);
    }, [emailVerificationParam, search]);
};
